module.exports = "h5 {\n  padding: 4px; }\n\n.custom-select {\n  display: block;\n  width: 100%; }\n"